module.exports = __webpack_public_path__ + "static/stageSet6-03439016e03831aadd07b9527c51b5de.jpg";